"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var noop_1 = tslib_1.__importDefault(require("lodash/noop"));
/**
 * @internal
 */
var Checkbox = /** @class */ (function (_super) {
    tslib_1.__extends(Checkbox, _super);
    function Checkbox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (e) {
            _this.props.onChange(e.target.checked);
        };
        return _this;
    }
    Checkbox.prototype.render = function () {
        var _a = this.props, disabled = _a.disabled, name = _a.name, text = _a.text, title = _a.title, value = _a.value, labelSize = _a.labelSize;
        var labelClasses = classnames_1.default("input-label-text", {
            "gd-label-small gd-checkbox-label-small": labelSize === "small",
            "gd-label gd-checkbox-label": labelSize === "normal",
        });
        return (react_1.default.createElement(react_1.default.Fragment, null,
            title ? react_1.default.createElement("h6", null, title) : null,
            react_1.default.createElement("label", { className: "input-checkbox-label" },
                react_1.default.createElement("input", { type: "checkbox", className: "input-checkbox", name: name, checked: value, disabled: disabled, onChange: this.onChange }),
                react_1.default.createElement("span", { className: labelClasses }, text))));
    };
    Checkbox.defaultProps = {
        disabled: false,
        name: "",
        text: "",
        title: "",
        value: false,
        labelSize: "small",
        onChange: noop_1.default,
    };
    return Checkbox;
}(react_1.default.PureComponent));
exports.Checkbox = Checkbox;
//# sourceMappingURL=Checkbox.js.map